jQuery(document).ready(function($) {
	console.log("News Alert Script geladen");
	const newsAlert = $('#news-alert');
	console.log("News Alert Element gefunden:", newsAlert.length > 0);
	if (newsAlert.length === 0) return;

	const closeNewsButton = $('#close-news');

	function showNewsAlert() {
			console.log("News Alert wird angezeigt");
			newsAlert.slideDown();
	}

	function hideNewsAlert() {
			console.log("News Alert wird versteckt");
			newsAlert.slideUp();
	}

	closeNewsButton.on('click', function() {
			hideNewsAlert();
	});

	// Zeige den Alert immer an, wenn die Seite geladen wird
	showNewsAlert();
});